import React from 'react';

// @ts-ignore
import Icon from 'assets/images/trojanSvg/trap-icon-empty.svg';

const SnapTrapStatus_1: React.FC = () => {
  return <img src={Icon} height={28} alt="Snap Status 1 Icon" />;
};

export default SnapTrapStatus_1;
